import { Text } from '../../cdl/Text/Text';
import { translate } from '../../common/helpers/translate.helper';
import { Box } from '../../common/ui/Box';
import { getHistoricalEquivalentGroups } from '../getHistoricalEquivalentGroups';
import type { DemandCalculation } from '../types/DemandCalculation';
import type { DemandProductCategory } from '../types/DemandProductCategory';

import { ResultingDemandCollapsable } from './ResultingDemandCollapsable';
import { ResultingDemandProductRow } from './ResultingDemandProductRow';

interface DemandHistoricalEquivalentsProps {
    calculation: DemandCalculation;
    category: DemandProductCategory;
    categoryLabel: string;
}

export const DemandHistoricalEquivalents = ({
    calculation,
    category,
    categoryLabel,
}: DemandHistoricalEquivalentsProps) => {
    const groups = getHistoricalEquivalentGroups(calculation, category);

    return (
        <Box display="flex" flexDirection="column" gap={8}>
            <Box display="flex" alignItems="baseline" justifyContent="space-between" gap={16}>
                <Text variant="small" fontWeight={600}>
                    {translate('demandDefinition.equivalentProducts')}
                </Text>
                <Text variant="small" color="foreground.muted">
                    {categoryLabel}
                </Text>
            </Box>
            {groups.length > 0 ? (
                <Box display="flex" flexDirection="column" gap={4}>
                    {groups.map((group) => (
                        <ResultingDemandCollapsable
                            key={group.key}
                            title={group.name}
                            summary={{
                                historicalVolume: group.historicalVolume,
                                adjustedVolume: group.historicalVolume,
                                deltaVolume: 0,
                            }}
                            liftingCount={group.liftingCount}
                            showChanges={false}
                        >
                            {group.products.map((product) => (
                                <ResultingDemandProductRow
                                    key={product.productId}
                                    product={product}
                                    showChanges={false}
                                />
                            ))}
                        </ResultingDemandCollapsable>
                    ))}
                </Box>
            ) : (
                <Text variant="small" color="foreground.muted">
                    {translate('demandDefinition.noHistoricalDemandDescription')}
                </Text>
            )}
        </Box>
    );
};
